"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _TableHeaderCell = require("../../components/TableHeaderCell/TableHeaderCell.styles");
/** @class TableHeaderMixin */
/** @method */
var TableHeaderMixin = function TableHeaderMixin(props) {
  return (0, _styledToken.default)(props.appearance === 'dark' ? 'Table.headerBackgroundColorDark' : 'Table.headerBackgroundColorLight', function (backgroundColor) {
    return (0, _styledComponents.css)(["", "{background-color:", ";}"], _TableHeaderCell.StyledTableHeaderCell, backgroundColor);
  })(props);
};
exports.TableHeaderMixin = TableHeaderMixin;